import http, { handleHttpError, handleHttpResponse } from 'services/http'
import { HTTPResponse, IPaginationResponse } from 'services/http/http.types'
import { IProjectStage, IProjectType } from './projectTypes.types'

const getList = async (): Promise<HTTPResponse<IPaginationResponse<IProjectType>>> => {
  const response =  await http.get<IProjectType[]>('/nsi/v1/project-types').then(handleHttpResponse).catch(handleHttpError)
  
  if(response.status === 'success') {
    return {
      status: response.status,
      body: {
        nextPage: null,
        prevPage: null,
        totalCount: response.body.length,
        items: response.body
      }
    }
  }

  return response
}

const getAll = async (): Promise<HTTPResponse<IProjectType[]>> => {
  return await http.get<IProjectType[]>('/nsi/v1/project-types').then(handleHttpResponse).catch(handleHttpError)
}

const getOne = async (id: IProjectType['id']): Promise<HTTPResponse<IProjectType>> => {
  return http
    .get('/nsi/v1/project-types/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

export interface ICreateProjectTypeDto {
  name: string
  description?: string
  projectStages: Array<{ projectStageId: IProjectStage['id']; orderingIndex: number }>
}

const create = async (dto: ICreateProjectTypeDto): Promise<HTTPResponse<IProjectType>> => {
  return http.post('/nsi/v1/project-types', dto).then(handleHttpResponse).catch(handleHttpError)
}

const update = async (dto: Partial<ICreateProjectTypeDto>, id: IProjectType['id']): Promise<HTTPResponse<IProjectType>> => {
  return http
    .patch('/nsi/v1/project-types/' + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const remove = async (id: IProjectType['id']): Promise<HTTPResponse<IProjectType>> => {
  return http
    .delete('/nsi/v1/project-types/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}


const projectTypesApi = {
  update,
  create,
  remove,
  getOne,
  getList,
  getAll,
}

export default projectTypesApi
